import { forwardRef } from "react";
import { Icon, type IconProps } from "../Icon";

export const Cpu = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  return (
    <Icon ref={ref} {...props}>
      <rect x="4" y="4" width="16" height="16" rx="2" ry="2" />
      <path d="M9 9h6v6H9zM9 1v3M15 1v3M9 20v3M15 20v3M20 9h3M20 14h3M1 9h3M1 14h3" />
    </Icon>
  );
});

Cpu.displayName = "Cpu";
